import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../components/ui/dialog';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// MaterialsTab — admin CRUD for predefined materials (sols / murs)
const MaterialsTab = () => {
  const [materials, setMaterials] = useState([]);
  const [showMaterialDialog, setShowMaterialDialog] = useState(false);
  const [materialForm, setMaterialForm] = useState({ name: '', category: 'sol', material_type: '' });

  const load = async () => {
    try {
      const r = await axios.get(`${API}/user/materials`, { withCredentials: true });
      setMaterials(r.data);
    } catch {
      toast.error('Erreur de chargement');
    }
  };
  useEffect(() => { load(); }, []);

  const handleCreateMaterial = async () => {
    try {
      await axios.post(
        `${API}/admin/materials?name=${encodeURIComponent(materialForm.name)}&category=${materialForm.category}&material_type=${encodeURIComponent(materialForm.material_type)}`,
        {}, { withCredentials: true }
      );
      toast.success('Matériau créé');
      load();
      setShowMaterialDialog(false);
      setMaterialForm({ name: '', category: 'sol', material_type: '' });
    } catch {
      toast.error('Erreur');
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-medium">Matériaux</h2>
        <Button onClick={() => setShowMaterialDialog(true)}>
          <Plus className="w-4 h-4 mr-2" />
          Nouveau matériau
        </Button>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <h3 className="font-medium text-gray-900 mb-4">Sols</h3>
          <div className="space-y-2">
            {materials.filter(m => m.category === 'sol' && m.is_predefined).map(mat => (
              <div key={mat.material_id} className="bg-white rounded-lg border border-gray-200 p-3 flex items-center justify-between">
                <div>
                  <p className="font-medium text-gray-900">{mat.name}</p>
                  <p className="text-xs text-gray-500">{mat.material_type}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-medium text-gray-900 mb-4">Murs</h3>
          <div className="space-y-2">
            {materials.filter(m => m.category === 'mur' && m.is_predefined).map(mat => (
              <div key={mat.material_id} className="bg-white rounded-lg border border-gray-200 p-3 flex items-center justify-between">
                <div>
                  <p className="font-medium text-gray-900">{mat.name}</p>
                  <p className="text-xs text-gray-500">{mat.material_type}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Dialog open={showMaterialDialog} onOpenChange={setShowMaterialDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Nouveau matériau</DialogTitle></DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-2">Nom *</label>
              <Input value={materialForm.name} onChange={(e) => setMaterialForm({ ...materialForm, name: e.target.value })} placeholder="Ex: Parquet Bambou" />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-2">Catégorie</label>
              <select value={materialForm.category} onChange={(e) => setMaterialForm({ ...materialForm, category: e.target.value })} className="w-full border border-gray-300 rounded-lg p-2">
                <option value="sol">Sol</option>
                <option value="mur">Mur</option>
              </select>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-2">Type</label>
              <Input value={materialForm.material_type} onChange={(e) => setMaterialForm({ ...materialForm, material_type: e.target.value })} placeholder="Ex: parquet, carrelage, peinture" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowMaterialDialog(false)}>Annuler</Button>
            <Button onClick={handleCreateMaterial} className="bg-blue-600 hover:bg-blue-700">Créer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MaterialsTab;
